import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';

declare var $:any;

@Component({
  selector: 'banner-slider',
  templateUrl: './banner-slider.component.html',
  styleUrls: ['./banner-slider.component.scss']
})
export class BannerSliderComponent implements OnInit,AfterViewInit {

  @Input("data") data:any = [];
  @ViewChild("banner") banner:any;

  constructor(){ }
 

  /**
   * 
   * Inicializa o banner
   * 
   */
  initBanner(){

    $(this.banner.nativeElement).slick({
      infinite: true,
      autoplay: true,
      dots: true,
      arrows: false,
      lazyLoad: 'ondemand'
    });
    $(this.banner.nativeElement).slick('refresh');

  }
  /**
   * 
   * Prev
   * 
   */
  prevSlide(){

    $(this.banner.nativeElement).slick("slickPrev");

  }
  /**
   * 
   * Next
   * 
   */
  nextSlide(){

    $(this.banner.nativeElement).slick("slickNext"); 
  
  }
  /**
   * 
   * Init
   * 
   **/
  ngOnInit(): void {
  }
  /**
   * 
   * After view
   * 
   **/
  ngAfterViewInit(): void {
    this.initBanner();
  }

}
